export const downloadApp = () => {


    const isWX = navigator.userAgent.match(/MicroMessenger/i) != null;
    const isIOS = !!(navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) != null);
    const isPC = navigator.userAgent.match(/mobile/i) == null;


    console.log('isWX:',isWX)
    console.log('isIOS:',isIOS)
    console.log('isPC:',isPC)
    const HREF = {
        wx: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.weimi.mzg.ws',
        ios: 'https://itunes.apple.com/cn/app/wen-shen-da-ka-zui-hao-wen/id1022212399?mt=8',
        adr: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.weimi.mzg.ws',
        pc: 'http://www.wenshendaka.com/'
    };


    if (isWX) {
        location.href = HREF.wx;
    }
    else if (isIOS) {
        location.href = HREF.ios;
    }
    else if (isPC) {
        location.href = HREF.pc;
    }
    else {
        // android
        location.href = HREF.adr;
    }
}


// WEBPACK FOOTER //
// ./src/apps/portfolio/utils.js